import { useEffect } from "react";

// 未マッチ URL (root / を含む) のフォールバック。ゲストアプリに単独のトップページは
// 無いため、メインサイトへリダイレクトする (JPTP_CANSEI-1506)。
const mainSiteUrl = "https://prestige.japanticket.com/";

export default function MainSiteRedirect() {
  useEffect(() => {
    window.location.replace(mainSiteUrl);
  }, []);

  return null;
}
